<template>
  <div>
    <banner />
    <div class="absolutecont">
      <div class="web">
        <div class="commonbg">
          <tab cur="/honor1" />
          <div class="mainbody" style="text-align: center">
            <img style="width: 100%" :src="baseApi+ 'upload/about/003.png'">
            <div class="my-div">
              <img style="margin: 20px 0 200px 0" :src="baseApi+ 'upload/about/001.png'">
              <div style="width: 10%"> </div>
              <img style="margin: 20px 0 200px 0" :src="baseApi+ 'upload/about/002.png'">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from '@/views/honor/componets/Banner'
import Tab from '@/views/honor/componets/Tab'
export default {
  components: { Banner, Tab },
  data () {
    return {
      baseApi: process.env.API_ROOT + 'static/'
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.my-div {
  display: flex;
  padding: 30px;
  img {
    width: 45%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/honor/honor1.vue